// Chord database
// Format: Chord name and its corresponding notes (for playback)
export const chordsData = {
  // Major chords
  'C': ['C4', 'E4', 'G4'],
  'D': ['D4', 'F#4', 'A4'],
  'E': ['E4', 'G#4', 'B4'],
  'F': ['F3', 'A3', 'C4'],
  'G': ['G3', 'B3', 'D4'],
  'A': ['A3', 'C#4', 'E4'],
  'B': ['B3', 'D#4', 'F#4'],
  
  // Flat major chords
  'Ab': ['Ab3', 'C4', 'Eb4'],
  'Bb': ['Bb3', 'D4', 'F4'],
  'Db': ['Db4', 'F4', 'Ab4'],
  'Eb': ['Eb3', 'G3', 'Bb3'],
  'Gb': ['Gb3', 'Bb3', 'Db4'],
  
  // Sharp major chords
  'F#': ['F#3', 'A#3', 'C#4'],
  'G#': ['G#3', 'B#3', 'D#4'],
  'C#': ['C#4', 'E#4', 'G#4'],
  'D#': ['D#4', 'F##4', 'A#4'],
  
  // Minor chords
  'Cm': ['C4', 'Eb4', 'G4'],
  'Dm': ['D4', 'F4', 'A4'],
  'Em': ['E4', 'G4', 'B4'],
  'Fm': ['F3', 'Ab3', 'C4'],
  'Gm': ['G3', 'Bb3', 'D4'],
  'Am': ['A3', 'C4', 'E4'],
  'Bm': ['B3', 'D4', 'F#4'],
  
  // Flat minor chords
  'Abm': ['Ab3', 'Cb4', 'Eb4'],
  'Bbm': ['Bb3', 'Db4', 'F4'],
  'Ebm': ['Eb3', 'Gb3', 'Bb3'],
  
  // 7th chords
  'C7': ['C4', 'E4', 'G4', 'Bb4'],
  'D7': ['D4', 'F#4', 'A4', 'C5'],
  'E7': ['E4', 'G#4', 'B4', 'D5'],
  'F7': ['F3', 'A3', 'C4', 'Eb4'],
  'G7': ['G3', 'B3', 'D4', 'F4'],
  'A7': ['A3', 'C#4', 'E4', 'G4'],
  'B7': ['B3', 'D#4', 'F#4', 'A4'],
  
  // Flat 7th chords
  'Ab7': ['Ab3', 'C4', 'Eb4', 'Gb4'],
  'Bb7': ['Bb3', 'D4', 'F4', 'Ab4'],
  'Eb7': ['Eb3', 'G3', 'Bb3', 'Db4'],
  
  // Major 7th chords
  'Cmaj7': ['C4', 'E4', 'G4', 'B4'],
  'Dmaj7': ['D4', 'F#4', 'A4', 'C#5'],
  'Emaj7': ['E4', 'G#4', 'B4', 'D#5'],
  'Fmaj7': ['F3', 'A3', 'C4', 'E4'],
  'Gmaj7': ['G3', 'B3', 'D4', 'F#4'],
  'Amaj7': ['A3', 'C#4', 'E4', 'G#4'],
  'Bmaj7': ['B3', 'D#4', 'F#4', 'A#4'],
  
  // Minor 7th chords
  'Cm7': ['C4', 'Eb4', 'G4', 'Bb4'],
  'Dm7': ['D4', 'F4', 'A4', 'C5'],
  'Em7': ['E4', 'G4', 'B4', 'D5'],
  'Fm7': ['F3', 'Ab3', 'C4', 'Eb4'],
  'Gm7': ['G3', 'Bb3', 'D4', 'F4'],
  'Am7': ['A3', 'C4', 'E4', 'G4'],
  'Bm7': ['B3', 'D4', 'F#4', 'A4'],
  
  // sus4 chords
  'Csus4': ['C4', 'F4', 'G4'],
  'Dsus4': ['D4', 'G4', 'A4'],
  'Esus4': ['E4', 'A4', 'B4'],
  'Fsus4': ['F3', 'Bb3', 'C4'],
  'Gsus4': ['G3', 'C4', 'D4'],
  'Asus4': ['A3', 'D4', 'E4'],
  'Bsus4': ['B3', 'E4', 'F#4'],
  
  // Flat sus4 chords
  'Absus4': ['Ab3', 'Db4', 'Eb4'],
  'Bbsus4': ['Bb3', 'Eb4', 'F4'],
  'Ebsus4': ['Eb3', 'Ab3', 'Bb3'],
};

// Common chord progressions (categorized by music genre)
export const progressions = {
  'Pop': [
    { name: 'Four-Chord Progression I-V-vi-IV', chords: ['C', 'G', 'Am', 'F'], description: 'One of the most common chord progressions in pop music', complexity: 1 },
    { name: 'Four-Chord Progression vi-IV-I-V', chords: ['Am', 'F', 'C', 'G'], description: 'Progression used by The Beatles and many pop songs', complexity: 1 },
    { name: 'Three-Chord Progression I-IV-V', chords: ['C', 'F', 'G'], description: 'Classic three-chord progression, suitable for simple and powerful songs', complexity: 1 },
    { name: 'Chord Progression ii-V-I', chords: ['Dm', 'G', 'C'], description: 'Common ending progression in jazz and many pop songs', complexity: 2 },
    { name: 'Doo-Wop Progression I-vi-IV-V', chords: ['C', 'Am', 'F', 'G'], description: 'Classic progression from the 50s and 60s, used in many ballads', complexity: 1 },
    { name: 'Pop Ballad I-V-vi-iii-IV', chords: ['C', 'G', 'Am', 'Em', 'F'], description: 'Emotional progression used in many modern pop ballads', complexity: 2 },
    { name: 'Modern Pop I-V-vi-IV-I-V-vi-IV', chords: ['C', 'G', 'Am', 'F', 'C', 'G', 'Am', 'F'], description: 'Extended repeated progression popular in contemporary hits', complexity: 2 },
    { name: 'Power Pop I-III-IV', chords: ['C', 'E', 'F'], description: 'Simple but effective progression with strong emotional impact', complexity: 1 }
  ],
  'Rock': [
    { name: 'Rock Progression I-V-vi-IV', chords: ['C', 'G', 'Am', 'F'], description: 'Widely used in modern rock songs', complexity: 1 },
    { name: 'Heavy Rock Progression i-VII-VI', chords: ['Am', 'G', 'F'], description: 'Suitable for heavier rock styles', complexity: 1 },
    { name: 'Blues Rock I-IV-V', chords: ['C7', 'F7', 'G7'], description: 'Rock progression with blues elements', complexity: 2 },
    { name: 'Alternative Rock vi-IV-I-V', chords: ['Am', 'F', 'C', 'G'], description: 'Common progression in 90s alternative rock', complexity: 1 },
    { name: 'Classic Rock I-bVII-IV', chords: ['C', 'Bb', 'F'], description: 'Iconic progression used in many classic rock anthems', complexity: 2 },
    { name: 'Hard Rock i-VI-VII', chords: ['Em', 'C', 'D'], description: 'Dark and powerful progression for harder rock styles', complexity: 2 },
    { name: 'Grunge Rock I-IV-III-VI', chords: ['C', 'F', 'E', 'A'], description: 'Dissonant progression popular in 90s grunge music', complexity: 2 },
    { name: 'Progressive Rock vi-V-IV', chords: ['Am', 'G', 'F'], description: 'Minor progression used in progressive and psychedelic rock', complexity: 2 }
  ],
  'Jazz': [
    { name: 'Jazz ii-V-I', chords: ['Dm7', 'G7', 'Cmaj7'], description: 'The most common chord progression in jazz', complexity: 2 },
    { name: 'Jazz Blues Progression', chords: ['C7', 'F7', 'G7'], description: 'Classic jazz blues style', complexity: 2 },
    { name: 'Jazz Standard', chords: ['Cmaj7', 'Dm7', 'G7', 'Cmaj7'], description: 'Progression used in many jazz standards', complexity: 2 },
    { name: 'Complex Jazz Progression', chords: ['Cmaj7', 'Am7', 'Dm7', 'G7'], description: 'Jazz progression with more color', complexity: 3 },
    { name: 'Minor Jazz Progression ii-V-i', chords: ['Dm7b5', 'G7', 'Cm7'], description: 'The minor equivalent of the ii-V-I, very common in jazz', complexity: 3 },
    { name: 'Jazz Turnaround I-VI-ii-V', chords: ['Cmaj7', 'A7', 'Dm7', 'G7'], description: 'Used as a turnaround at the end of many jazz standards', complexity: 3 },
    { name: 'Modal Jazz Progression', chords: ['Dm7', 'Em7', 'Fmaj7', 'G7'], description: 'Used in modal jazz to create a more open sound', complexity: 3 },
    { name: 'Bossa Nova Progression i-IV-VII-III', chords: ['Am7', 'Dmaj7', 'G7', 'Cmaj7'], description: 'Common in Latin jazz and bossa nova styles', complexity: 3 }
  ],
  'Electronic': [
    { name: 'EDM Progression', chords: ['C', 'G', 'Am', 'F'], description: 'Most popular chord progression in electronic dance music', complexity: 1 },
    { name: 'Ambient Electronic', chords: ['Am', 'F', 'C', 'G'], description: 'Electronic music that creates an atmospheric feel', complexity: 1 },
    { name: 'Future Bass', chords: ['Cm', 'Gm', 'Eb', 'Bb'], description: 'Minor progression in future bass and electronic music', complexity: 2 },
    { name: 'Synthwave Progression', chords: ['Cm', 'Ab', 'Eb', 'Bb'], description: 'Progression with a retro synthesizer feel', complexity: 2 },
    { name: 'House Music I-V-vi', chords: ['C', 'G', 'Am'], description: 'Simple but effective progression used in house music', complexity: 1 },
    { name: 'Trance Progression vi-IV-I-V', chords: ['Am', 'F', 'C', 'G'], description: 'Euphoric progression common in trance music', complexity: 1 },
    { name: 'Dubstep Progression i-III-VII-VI', chords: ['Cm', 'Eb', 'Bb', 'Ab'], description: 'Dark progression often used in dubstep and bass music', complexity: 2 },
    { name: 'Chillwave III-IV-i', chords: ['E', 'F', 'Cm'], description: 'Relaxed progression with an unexpected twist', complexity: 2 }
  ],
  'Folk': [
    { name: 'Traditional Folk', chords: ['C', 'Am', 'F', 'G'], description: 'Most common progression in folk guitar songs', complexity: 1 },
    { name: 'Modern Folk', chords: ['C', 'Em', 'Am', 'F'], description: 'Modern folk progression with melancholic colors', complexity: 1 },
    { name: 'Country Folk', chords: ['G', 'Em', 'C', 'D'], description: 'Folk progression with country style', complexity: 1 },
    { name: 'Narrative Folk', chords: ['C', 'G', 'Am', 'Em'], description: 'Suitable for storytelling folk songs', complexity: 1 },
    { name: 'Celtic Folk I-VII-IV', chords: ['D', 'C', 'G'], description: 'Progression commonly found in Celtic folk music', complexity: 1 },
    { name: 'Americana I-V-IV-IV', chords: ['G', 'D', 'C', 'C'], description: 'Simple but effective progression used in American folk', complexity: 1 },
    { name: 'Folk Ballad vi-III-VII-i', chords: ['Am', 'C', 'G', 'Em'], description: 'Minor progression used in traditional folk ballads', complexity: 2 },
    { name: 'Appalachian Folk I-vi-IV-V', chords: ['C', 'Am', 'F', 'G'], description: 'Traditional progression from Appalachian folk music', complexity: 1 }
  ],
  'Classical': [
    { name: 'Pachelbel Canon', chords: ['C', 'G', 'Am', 'Em', 'F', 'C', 'F', 'G'], description: 'Famous progression from Pachelbel\'s Canon in D', complexity: 2 },
    { name: 'Baroque Cycle I-IV-vii°-iii-vi-ii-V-I', chords: ['C', 'F', 'Bdim', 'Em', 'Am', 'Dm', 'G', 'C'], description: 'Circle progression common in Baroque music', complexity: 3 },
    { name: 'Romantic Era I-vi-IV-V', chords: ['C', 'Am', 'F', 'G'], description: 'Simple progression used in many Romantic era pieces', complexity: 1 },
    { name: 'Mozart\'s Progression I-IV-I⁶₄-V⁷', chords: ['C', 'F', 'C', 'G7'], description: 'Classic cadential progression used by Mozart', complexity: 2 },
    { name: 'Classical Minor i-iv-V-i', chords: ['Am', 'Dm', 'E', 'Am'], description: 'Common minor progression in classical music', complexity: 2 },
    { name: 'Chopin Progression i-V-VI-III-iv', chords: ['Am', 'E', 'F', 'C', 'Dm'], description: 'Emotional progression found in Chopin\'s works', complexity: 3 }
  ],
  'Blues': [
    { name: 'Basic Blues I-IV-I-V-IV-I', chords: ['C7', 'F7', 'C7', 'G7', 'F7', 'C7'], description: 'Foundation of 12-bar blues structure', complexity: 2 },
    { name: 'Jazz Blues I-IV-I-V-i-IV', chords: ['C7', 'F7', 'C7', 'G7', 'Cm7', 'F7'], description: 'Blues progression with a jazz twist', complexity: 3 },
    { name: 'Quick Change Blues I-IV-I-V', chords: ['C7', 'F7', 'C7', 'G7'], description: 'Blues progression with a quick IV chord', complexity: 2 },
    { name: 'Stormy Monday I-IV-V-IV', chords: ['C7', 'F7', 'G7', 'F7'], description: 'Progression from the famous blues standard', complexity: 2 },
    { name: 'Minor Blues i-iv-i-V', chords: ['Am7', 'Dm7', 'Am7', 'E7'], description: 'Blues progression in a minor key', complexity: 2 },
    { name: 'Shuffle Blues I-I-I-I-IV-IV-I-I-V-IV-I-V', chords: ['C7', 'C7', 'C7', 'C7', 'F7', 'F7', 'C7', 'C7', 'G7', 'F7', 'C7', 'G7'], description: 'Complete 12-bar blues progression with a shuffle feel', complexity: 3 }
  ]
}; 